((app, ng) => {

    app.component("icomplyButton",
        {
            template: `<md-button class="btn-accent" ng-click="$ctrl.goToIComply()">Start iComply Transaction</md-button>`,
            controller: icomplyButtonController
        });

    function icomplyButtonController(icomplyApi, iComplySettings) {
        const $ctrl = this;

        const goToIComply = () => {
            const w = window.open();
            w.document.write("Loading...");
            icomplyApi.getToken().then(response => {
                const url = `${iComplySettings.baseUrl}/Sso?accesstoken=${response.Token}&expiration=${response.Expiration}`;
                w.location.href = url;
            }, () => {
                w.document.write("Failed. Tehre was an error accessing this resource.");
            });
        }

        ng.extend($ctrl,
            {
                goToIComply,
            });
    }

})(window.app, window.angular);